import { createStore } from 'satcheljs';
import getDefaultFilePickerStore from '../utils/getDefaultFilePickerStore';
import type FilePickerStore from './schema/FilePickerStore';

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS2345 (8,71): Argument of type '{ viewState: { isOpen: boolean; preloadState: FilePickerPreloadState; fileSelectionFilter: FileSelectionFilter; fileProvidersFilter: FileProvidersFilter; ... 5 more ...; showFileProviderInlineView: boolean; }; }' is not assignable to parameter of type 'FilePickerStore'.
// @ts-expect-error
const getFilePickerStore = createStore<FilePickerStore>('filepicker', getDefaultFilePickerStore());
export { getFilePickerStore };
